import * as R from 'ramda';
import React, { forwardRef, useEffect, useState } from "react";

const MySlider = ({ target }) => {
  const [progress, setProgress] = useState(0);
  const [width, setWidth] = useState("100%");

  useEffect(() => {
    if (!target) return;

    const updateProgress = () => {
      const currentProgress = (target.currentTime / target.duration) * 100;
      setProgress(currentProgress);
    };

    const resizeObserver = new window.ResizeObserver((entries) => {
      for (let entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });

    // Set initial width
    setWidth(target.clientWidth);

    resizeObserver.observe(target);

    target.addEventListener("timeupdate", updateProgress);

    return () => {
      target.removeEventListener("timeupdate", updateProgress);
      resizeObserver.unobserve(target);
    };
  }, [target]);

  const handleClick = (e) => {
    if (!target) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    target.currentTime = (clickX / rect.width) * target.duration;
  };

  return (
    <div
      className="slider-outer cursor-pointer"
      onClick={handleClick}
      style={{
        position: "relative",
        // width: `${width}px`,
        height: "10px",
        background: "#ccc",
        top: -6,
      }}
    >
      <div
        className="slider-inner transition-all-350"
        style={{ width: `${progress}%`, height: "100%", background: "#007bff" }}
      ></div>
    </div>
  );
};

export const VideoWithSlider = forwardRef((props, ref) => {
  const active = props.active;
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    if (active && ref.current) {
      setTimeout(() => {
        setRefreshKey(refreshKey + 1);
      }, 300);
    }
  }, [ref, active]);

  const src = R.pathOr("", ["src"], props);
  if(src.endsWith('/')){
    //  还未获取到视频地址
    return null;
  }

  return (
    <div className="position-relative flex-x-center flex-y-center">
      <div>
        <video ref={ref} {...props} />
        <MySlider target={ref.current} {...props} key={refreshKey} />
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/video-with-slider.js